<template>
  <div style="padding: 24px" class="big">
    <div style="border: solid 1px #c9cbd6">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%; min-width: 1000px"
        :header-cell-style="{ background: '#F5F5F5' }"
      >
        <el-table-column label="生成时间" prop="create_time"></el-table-column>
        <el-table-column
          label="处方总金额"
          prop="total_price"
        ></el-table-column>
        <el-table-column label="处方数量" prop="total_num"></el-table-column>
        <el-table-column label="转账备注" prop="remark"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="checkCode(scope.row.accounts_id)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('476') : false
              "
              >查看二维码</el-button
            >
            <el-button
              type="text"
              @click="voidLog(scope.row.accounts_id)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('477') : false
              "
              >作废</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 24px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      ></el-pagination>
    </div>
    <el-dialog
      title="对公转账二维码记录"
      :visible.sync="codebox"
      width="580px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px">
        <div class="flex_between" style="text-align: left; font-size: 15px">
          <div>
            <div>
              <span style="display: inline-block; width: 100px"
                >处方总金额</span
              >
              <span>{{ codeInfo.total_price }}</span>
            </div>
            <div style="margin: 10px 0">
              <span style="display: inline-block; width: 100px">处方数量</span>
              <span>{{ codeInfo.total_num }}</span>
            </div>
            <div>
              <span style="display: inline-block; width: 100px">转账备注</span>
              <span>{{ codeInfo.remark }}</span>
            </div>
          </div>
          <div>
            <img
              :src="codeInfo.qrcode"
              alt
              style="width: 130px; height: 130px"
            />
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6; margin-top: 10px">
          <el-table
            ref="multipleTable"
            :data="codeInfo.list"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="开方时间"
              prop="create_time"
              width="145"
            ></el-table-column>
            <el-table-column
              label="患者姓名"
              prop="user_name"
            ></el-table-column>
            <el-table-column
              label="医生姓名"
              prop="doctor_name"
            ></el-table-column>
            <el-table-column label="处方号" prop="pre_id"></el-table-column>
            <el-table-column label="处方金额" prop="amount"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      codebox: false,
      codeInfo: {},
      tableData: [],
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        status: 1,
      };
      this.axios
        .post("platform/prescription/getPrescriptionAccountsList", data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format("YYYY-MM-DD HH:mm");
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },

    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //查看二维码
    checkCode(accounts_id) {
      this.axios
        .post("platform/prescription/getPrescriptionAccountsInfo", {
          accounts_id,
        })
        .then((res) => {
          if (res.code == 0) {
            this.codeInfo = res.data;
            this.codeInfo.list = this.codeInfo.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format("YYYY-MM-DD HH:mm");
              return item;
            });
            this.codebox = true;
          }
        });
    },
    //作废
    voidLog(accounts_id) {
      this.$confirm(
        "确定要作废二维码吗？作废后该记录失效，不可填报。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          this.axios
            .post("platform/prescription/delPrescriptionAccounts", {
              accounts_id,
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("记录已作废");
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
  },
  created() {
    this.getList();
  },
  activated() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.mydivider {
  margin: 0;
}

.btnbox {
  text-align: left;
  margin: 20px 0;
  padding-left: 14px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
  .item {
    margin-right: 30px;
    margin-top: 24px;
  }
}
</style>
